import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { getAllDocumentExpressRatesRedux } from "../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Clock as ClockIcon } from "react-feather";

export class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      time: "",
    };
  }

  componentWillMount = () => {
    this.timeInterval = setInterval(() => {
      let date = new Date();
      let time = date.toLocaleTimeString("en-US");
      this.setState({
        time,
      });
    }, 1000);
  };

  componentWillUnmount = () => {
    clearInterval(this.timeInterval);
  };

  render() {
    const { open } = this.state;
    let date = new Date();
    let onlyDate = date.toDateString();

    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 9,
          background: "rgba(251, 148, 4, 0.08)",
          border: "1px solid rgba(251, 148, 4, 0.2)",
          borderRadius: 999,
          padding: "6px 14px",
        }}
      >
        <ClockIcon size={13} color="#fb9404" />
        <span
          style={{
            fontFamily: '"JetBrains Mono", "SFMono-Regular", Consolas, monospace',
            fontSize: 12.5,
            fontWeight: 700,
            color: "#1a1d29",
            letterSpacing: "0.01em",
          }}
        >
          {this.state.time}
        </span>
        <span
          style={{
            width: 1,
            height: 12,
            background: "rgba(26, 29, 41, 0.14)",
          }}
        />
        <span
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: "#5b5f6e",
          }}
        >
          {onlyDate}
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpressDocumentsRates: state.expressRatesDocuments.expressRatesDocuments,
  };
};

export default connect(mapStateToProps, { getAllDocumentExpressRatesRedux })(
  Clock
);
